import onboarding from '@onboarding-reducers/onboardingReducer';

export default onboarding;
